module.exports = __webpack_public_path__ + "img/vertical_6_6_5010.cb16c9e9.png";